export default __webpack_public_path__ + "static/media/0xec482de9569a5ea3dd9779039b79e53f15791fde.286f8775.webp";